import { render } from "./DefaultPostRelatedSectionDocCmp.vue?vue&type=template&id=69a348d2"
import script from "./DefaultPostRelatedSectionDocCmp.vue?vue&type=script&lang=js"
export * from "./DefaultPostRelatedSectionDocCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__